import type { NDateLocale } from './enUS'
import { sq } from 'date-fns/locale'

const dateSqAL: NDateLocale = {
  name: 'sq-AL',
  locale: sq
}

export default dateSqAL
